module.exports = __webpack_public_path__ + "BalaSirimage-51966c34.webp";